import { ContentLoader } from "components/common/loader/ContentLoader";
import { Wrapper } from "components/common/utils/wrapper/Wrapper";
import { createEvent, createTime } from "components/graphql/queries";
import * as JSCookie from "js-cookie";
import { RolesSystem } from 'lib/enums/RolesSystem.enum';
import { Padding } from "lib/styles/Padding";
import { RouteTo } from "lib/utils/routing";
import * as React from "react";
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import { fetchGraphQL } from "services/graphql/GraphQL";
import UIDucks from 'stores/ducks/UI.duck';
import UserDucks from 'stores/ducks/User.duck';
import CreateEventForm from "./modules/create.form";



interface IDashboardOverviewProps {

  user: any;
  token?: string;
  dispatch?: any;
  match?: any;
  location?: any;
  history?: any;
  users?: any;
  event?: object;

  isOpened?: any;
}
class CreateEventPage extends React.Component<IDashboardOverviewProps> {
  public state = {
    isLoading: false,
    event: { id: null, onSale: true, lastInitialOnly: false }
  };

  constructor(props) {
    super(props);
    this.handleCreateEvent = this.handleCreateEvent.bind(this);
  }

  public componentDidMount() {
    if (!this.props.isOpened) {
      return;
    }
    this.props.dispatch(UIDucks.setAppBar(!this.props.isOpened));
  }

  public handleCreateEvent(newData: any) {
    this.setState(
      (oldState: any) => {
        return {
          event: {
            ...oldState.event,
            ...newData
          },
          isLoading: true
        };
      },
      () => {
        const eventLocal: any = this.state.event;

        delete eventLocal.checkers;
        delete eventLocal.promoters;
        delete eventLocal.hosts;
        const time = eventLocal.time;
        delete eventLocal.time;

        eventLocal.timezoneOffset = eventLocal.timezoneOffset.toString();
        eventLocal.creationTimeZone = (-1 * new Date().getTimezoneOffset() / 60).toString();

        if (eventLocal.agreed !== undefined && eventLocal.agreed !== null) {
          delete eventLocal.agreed;
        }

        fetchGraphQL(createEvent(), JSCookie.get("token"), {
          event: eventLocal
        }).then(result => {
          time.eventId = result.event.create.id;
          fetchGraphQL(
            createTime(), undefined, {
            time
          }
          ).then(res => {

            const user = JSON.parse(JSON.stringify(this.props.user))
            const newObj = {
              id: result.event.create.id,
              roles: [RolesSystem.HOST]
            }
            user.events[Object.keys(this.props.user.events).length] = newObj;
            this.props.dispatch(UserDucks.setUser(user));
            this.props.history.push(RouteTo.eventEdit(result.event.create.id));
            this.setState({
              isLoading: false
            });
          })
        });
      }
    );
  }

  public render() {
    return (
      <ContentLoader isLoading={this.state.isLoading}>
        <Wrapper className={Padding.medium}>
          <CreateEventForm
            event={this.state.event}
            users={this.props.users}
            onSave={this.handleCreateEvent}
            user={this.props.user}
          />
        </Wrapper>
      </ContentLoader>
    );
  }
}

const mapStateToProps = state => {
  return {
    isOpened: UIDucks.getIsAppBarOpen(state),
    user: UserDucks.getOwnState(state)
  };
};

export default withRouter(connect(mapStateToProps)(CreateEventPage));



// WEBPACK FOOTER //
// ./src/pages/manage/events/create/CreateEvent.page.tsx